module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/User-9bdaaba232a4ed435df0edd68b4f65c8.svg";